module.exports = __webpack_public_path__ + "img/clogo.860ac844.png";